<template>
  <v-footer dark>
    <v-container>
      <v-row>
        <v-col class="col-3 d-none d-lg-flex"></v-col>
        <v-col class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <h3>
            <span class="orange--text text--darken-4">{{
              $t("footer.contact_undergraduate")
            }}</span>
          </h3>
          <v-divider color="#757575"></v-divider>
          <v-icon>mdi-phone</v-icon> : 0 2329 8201 {{ $t("footer.ext") }} 201 - 210<br />
          <v-icon>mdi-phone</v-icon> : 0 2329 8202 {{ $t("footer.ext") }} 201 - 210<br />
          <v-icon>mdi-phone</v-icon> : 0 2329 8203 {{ $t("footer.ext") }} 201 - 210<br />
          <v-icon>mdi-phone</v-icon> : 0 2329 8205 {{ $t("footer.ext") }} 201 - 210<br />
          <v-icon>mdi-phone</v-icon> : 0 2329 8163 {{ $t("footer.ext") }} 201 - 210<br />
          <v-icon>mdi-at</v-icon> : enroll-reg@kmitl.ac.th<br />
          <v-icon>mdi-facebook</v-icon> :
          <a
            href="https://www.facebook.com/reg.kmitl"
            target="blank"
            style="text-decoration: none; color:white;"
            >reg.kmitl</a
          >
        </v-col>
        <v-col class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <h3>
            <span class="orange--text text--darken-4">{{
              $t("footer.contact_graduate")
            }}</span>
          </h3>
          <v-divider color="#757575"></v-divider>
          <v-icon>mdi-phone</v-icon> : 0 2329 8201 {{ $t("footer.ext") }} 101 - 102, 502 - 503<br />
          <v-icon>mdi-phone</v-icon> : 0 2329 8202 {{ $t("footer.ext") }} 101 - 102, 502 - 503<br />
          <v-icon>mdi-phone</v-icon> : 0 2329 8203 {{ $t("footer.ext") }} 101 - 102, 502 - 503<br />
          <v-icon>mdi-phone</v-icon> : 0 2329 8205 {{ $t("footer.ext") }} 101 - 102, 502 - 503<br />
          <v-icon>mdi-phone</v-icon> : 0 2329 8163 {{ $t("footer.ext") }} 101 - 102, 502 - 503<br />
          <v-icon>mdi-at</v-icon> : grad-reg@kmitl.ac.th<br />
          <v-icon>mdi-facebook</v-icon> :
          <a
            href="https://www.facebook.com/reg.kmitl"
            target="blank"
            style="text-decoration: none; color:white;"
            >reg.kmitl</a
          >
        </v-col>
        <v-col class="col-md-12 col-lg-3 col-xl-3">
          <h3>
            <span class="orange--text text--darken-4"
              >{{ $t("footer.registrar") }}
            </span>
          </h3>
          <v-divider color="#757575"></v-divider>
          {{ $t("app_bar.university_name") }}<br />
          {{ $t("footer.address1") }}<br />
          {{ $t("footer.address2") }}<br />
          {{ $t("footer.address3") }}
        </v-col>
      </v-row>

      <v-row>
        <v-col class="col-3 d-none d-lg-flex"></v-col>
        <v-col class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
          <h3>
            <span class="orange--text text--darken-4"
              >King Mongkut's Institute of Technology Ladkrabang</span
            >
            2021-{{ new Date().getFullYear() }} All Rights Reserved.
          </h3>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {};
</script>
